import type { WorkflowRead } from '../client'

export const RUN_PREFIX = 'Run the workflow "'

export function runMessage(workflow: WorkflowRead, inputs: Record<string, string>) {
  const lines = workflow.inputs
    .filter(({ name }) => inputs[name]?.trim())
    .map(({ name, label }) => `- ${label}: ${inputs[name].trim()}`)
  return [`${RUN_PREFIX}${workflow.name}".`, ...lines].join('\n')
}
